export const menu = {
  stock: '(在庫管理)入庫',
  ship: '(在庫管理)出庫',
  lend: '(貸出管理)貸出',
  return: '(貸出管理)返却',
  defective: '(在庫変動)NG品',
  lostItem: '(在庫変動)紛失品',
  productDetail: '履歴照会',
}
